import '@shui/core/sh-spinner';

import { Component, booleanAttribute, input, ChangeDetectionStrategy } from '@angular/core';

export type ShSpinnerSize = 'm' | 's' | 'l';

@Component({
    selector: 'sh-spinner',
    template: '<ng-content />',
    imports: [],
    changeDetection: ChangeDetectionStrategy.Eager,
    host: {
        '[attr.label]': 'label() ?? null',
        '[attr.size]': 'size() ?? null',
        '[attr.overlay]': 'overlay() ? "" : null'
    }
})
export class ShSpinnerComponent {
    /** Helper text displayed below the spinner. Keep it short (1–2 words, e.g. `Loading…`). */
    public readonly label = input<string | undefined>(undefined);

    /** Spinner size. `'m'` = 3 rem (default), `'s'` = 2 rem. */
    public readonly size = input<ShSpinnerSize | undefined>(undefined);

    /** When `true`, renders the spinner over a full-page overlay that blocks interaction. */
    public readonly overlay = input(false, { transform: booleanAttribute });
}
